__turbopack_context__.v({
  "osPicker": "OsPicker-module__7sMzlq__osPicker",
  "osPickerContent": "OsPicker-module__7sMzlq__osPickerContent",
  "osPickerTab": "OsPicker-module__7sMzlq__osPickerTab",
  "osPickerTabActive": "OsPicker-module__7sMzlq__osPickerTabActive",
  "osPickerTabs": "OsPicker-module__7sMzlq__osPickerTabs",
});
